import React from 'react';
import { func, node, string, bool } from 'prop-types';
import { noop } from '@prisjakt/ui-base';

import * as S from './styles';

class OutsideClickTracker extends React.PureComponent {
  listenerOptions = { capture: true };

  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.active) {
      this.addListeners();
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  componentDidUpdate(prevProps) {
    if (this.props.active && !prevProps.active) {
      this.addListeners();
    }
    if (!this.props.active && prevProps.active) {
      this.removeListeners();
    }
  }

  addListeners() {
    window.addEventListener(
      'mousedown',
      this.mouseDownListener,
      this.listenerOptions
    );
    window.addEventListener('click', this.clickListener, this.listenerOptions);
    window.addEventListener('keyup', this.keyUpListener, this.listenerOptions);
  }

  removeListeners() {
    window.removeEventListener(
      'mousedown',
      this.clickListener,
      this.listenerOptions
    );
    window.removeEventListener(
      'click',
      this.clickListener,
      this.listenerOptions
    );
    window.removeEventListener(
      'keyup',
      this.keyUpListener,
      this.listenerOptions
    );
  }

  mouseDownListener = e => {
    if (
      this.props.active &&
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(e.target) &&
      document.getElementById('root').contains(e.target)
    ) {
      this.props.onMouseDownOutside();
    }
  };

  clickListener = e => {
    if (
      this.props.active &&
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(e.target) &&
      // We dont want to close things like the mobile sidebar when trying to close
      // a toast notification or when accepting cookies from the cookie banner
      document.getElementById('root').contains(e.target)
    ) {
      e.stopPropagation();
      this.props.onClickOutside();
    }
  };

  keyUpListener = e => {
    if (this.props.active && e.keyCode === 27) {
      this.props.onEscapeKey();
    }
  };

  render() {
    return (
      <>
        <S.OutsideArea />
        <S.InsideArea className={this.props.className} ref={this.wrapperRef}>
          {this.props.children}
        </S.InsideArea>
      </>
    );
  }
}

OutsideClickTracker.propTypes = {
  children: node,
  className: string,
  onMouseDownOutside: func,
  onClickOutside: func,
  onEscapeKey: func,
  active: bool,
};

OutsideClickTracker.defaultProps = {
  children: undefined,
  className: undefined,
  onMouseDownOutside: noop,
  onClickOutside: noop,
  onEscapeKey: noop,
  active: true,
};

export default OutsideClickTracker;
